import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { checkBlackIcon } from "../../assets/icons";

const CustomDateEditor = forwardRef((props, ref) => {
  const { value } = props;
  const [epoch, setEpoch] = useState(value ? new Date(value) : new Date());
  const pickerRef = useRef();

  useEffect(() => {
    if (pickerRef.current) {
      pickerRef.current.setOpen(true);
    }
  }, []);

  const onDateChange = (date) => {
    setEpoch(date);
  };

  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return moment(epoch).toISOString();
      },
    };
  });

  return (
    <>
      <DatePicker
        className="w-full px-4 text-sm text-black border-none focus:ring-transparent"
        portalId="date-picker-portal"
        selected={epoch}
        onChange={onDateChange}
        showMonthDropdown
        showYearDropdown
        ref={pickerRef}
        dateFormat="dd/MM/yyyy"
      />
      <img
        src={checkBlackIcon}
        alt="check-icon"
        className="absolute right-2 top-3 w-4 h-4 cursor-pointer"
        onClick={() => props.api.stopEditing()}
      />
    </>
  );
});

CustomDateEditor.displayName = "CustomDateEditor";

export default CustomDateEditor;
